module.exports = __webpack_public_path__ + "img/a-1.8881df41.png";